import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';

import { User } from '../_models';

@Injectable()
export class UserService {
    constructor(private HttpClient : HttpClient, Client) { }

    getAll() {
        return this.HttpClient .get<User[]>('/api/users');
    }

    getById(id: number) {
        return this.HttpClient .get('/api/users/' + id);
    }

    create(user: User) {
        return this.HttpClient .post('/api/users', user);
    }

    update(user: User) {
        return this.HttpClient .put('/api/users/' + user.id, user);
    }

    delete(id: number) {
        return this.HttpClient .delete('/api/users/' + id);
    }
}


// WEBPACK FOOTER //
// ./src/app/_services/user.service.ts